import React from 'react'
import { IoDocumentTextOutline } from "react-icons/io5";
const Signatures = () => {
  return (
    <div style={{margin:'10% auto', textAlign:'center'}}><IoDocumentTextOutline className='content-icon'/>
    <p style={{color:'grey'}}>No signed documents</p></div>
  )
}

export default Signatures